import { F18_SERVICES } from '../configs/Config'
import { apiCMSWithToken } from './axios'


const url = {
  duplicatePostSearch: `/post/duplicate`,
  duplicatePostSellSearch: `/post/internal`,
  duplicatePostDelete: `/post/delete/duplicate`,
}
export async function duplicatePostSearch(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${url.duplicatePostSearch}?${params}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function duplicatePostSellSearch(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(
      `${url.duplicatePostSellSearch}?${params}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function duplicatePostDelete(body) {
  const response = await apiCMSWithToken.delete(`${url.duplicatePostDelete}`, {
    data: body
  })
  return response
}


export default {
  duplicatePostSearch,
  duplicatePostSellSearch,
  duplicatePostDelete

}
